import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';

import { GridBreak } from 'components/GridBreak';
import FieldSelectList from 'components/forms/fields/FieldSelectList';
import FieldAutocompleteList from 'components/forms/fields/FieldAutocompleteList';
import { applicantDegree, applicantExperience, jobContract, jobFunction, jobType, salaryPer } from './constants';

const Form = () => {
    const {register, control, formState: {errors}} = useFormContext<any>();

    return (
        <Box sx={{p: '1rem 1.5rem'}}>
            <Box>
                <Typography variant="h5">Informations</Typography>
                <Grid container spacing={2} columns={{xs: 1, sm: 3}}>
                    <Grid item xs={1}>
                        <TextField
                            id='job_title'
                            label='Titre de la mission'
                            {...register('job_title')}
                            autoComplete='off'
                            error={errors?.job_title ? true : false}
                            helperText={errors?.job_title ? errors.job_title.message as string : null}
                        />
                    </Grid>
                    <GridBreak />
                    <Grid item xs={2}>
                        <TextField
                            id='address'
                            label="Adresse"
                            {...register('address.address')}
                            autoComplete='off'
                            error={errors?.address && (errors.address as any).address ? true : false}
                            helperText={errors?.address && (errors.address as any).address ? (errors.address as any).address.message as string : null}
                        />
                    </Grid>
                    <GridBreak />
                    <Grid item xs={1} sm={3}>
                        <TextField
                            id="job_description"
                            label="Descriptif du poste"
                            multiline
                            rows={4}
                            {...register('job_description')}
                            autoComplete='off'
                            error={errors?.job_description ? true : false}
                            helperText={errors?.job_description ? errors.job_description.message as string : null}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Divider sx={{my: '1rem'}} />
            <Box sx={{ mt: '1rem' }}>
                <Typography variant="h5">Contrat</Typography>
                <Grid container spacing={2} columns={{xs: 1, sm: 3}}>
                    <Grid item xs={1}>
                        <FieldSelectList
                            control={control}
                            fieldName='job_contract'
                            options={jobContract}
                            labelId='job_contract'
                            label='Type de mission'
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <FieldSelectList
                            control={control}
                            fieldName='job_type'
                            options={jobType}
                            labelId='job_type'
                            label='Type de contrat'
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <FieldAutocompleteList
                            control={control}
                            options={jobFunction}
                            fieldName='job_industry'
                            labelId='job_industry'
                            label="Secteur d'activité"
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <TextField
                            id="salary_from"
                            label="Salaire minimum"
                            {...register('salary_from')}
                            autoComplete='off'
                            error={errors?.salary_from ? true : false}
                            helperText={errors?.salary_from ? errors.salary_from.message as string : null}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <TextField
                            id="salary_to"
                            label="Salaire maximum"
                            {...register('salary_to')}
                            autoComplete='off'
                            error={errors?.salary_to ? true : false}
                            helperText={errors?.salary_to ? errors.salary_to.message as string : null}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <FieldSelectList
                            control={control}
                            fieldName='salary_cadence'
                            options={salaryPer}
                            labelId='salary_cadence'
                            label="Periodicité"
                        />
                    </Grid>
                    <Grid item xs={1} sm={3}>
                        <TextField
                            id="salary_benefits"
                            label="Avantages salariaux"
                            multiline
                            rows={4}
                            {...register('salary_benefits')}
                            autoComplete='off'
                            error={errors?.salary_benefits ? true : false}
                            helperText={errors?.salary_benefits ? errors.salary_benefits.message as string : null}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Divider sx={{my: '1rem'}} />
            <Box sx={{ mt: '1rem' }}>
                <Typography variant="h5">Profil</Typography>
                <Grid container spacing={2} columns={{xs: 1, sm: 3}}>
                    <Grid item xs={1}>
                        <FieldSelectList
                            control={control}
                            fieldName='applicant_degree'
                            options={applicantDegree}
                            labelId='applicant_degree'
                            label="Niveau d'étude"
                        />
                    </Grid>
                    <Grid item xs={1}>
                        <FieldSelectList
                            control={control}
                            fieldName='applicant_experience'
                            options={applicantExperience}
                            labelId='applicant_experience'
                            label="Niveau d'expérience métier"
                        />
                    </Grid>
                    <Grid item xs={1} sm={2}>
                        <TextField
                            id="applicant_qualifications"
                            label="Compétences spécifiques"
                            {...register('applicant_qualifications')}
                            autoComplete='off'
                            error={errors?.applicant_qualifications ? true : false}
                            helperText={errors?.applicant_qualifications ? errors.applicant_qualifications.message as string : null}
                        />
                    </Grid>
                    <Grid item xs={1} sm={3}>
                        <TextField
                            id="applicant_profile"
                            label="Descriptif du profil"
                            multiline
                            rows={4}
                            {...register('applicant_profile')}
                            autoComplete='off'
                            error={errors?.applicant_profile ? true : false}
                            helperText={errors?.applicant_profile ? errors.applicant_profile.message as string : null}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export { Form };